import React, { useState, useEffect } from "react";
import {
  CheckIcon,
  XMarkIcon,
  ComputerDesktopIcon,
  UserGroupIcon,
  PaperClipIcon,
  DocumentIcon,
  PhotoIcon,
  DocumentTextIcon,
  ArchiveBoxIcon,
  TrashIcon,
  ArrowUpTrayIcon,
} from "@heroicons/react/24/outline";
import { SelectCompanies } from "./SelectCompanies";

// Límite de archivos individuales +
const MAX_ARCHIVOS_INDIVIDUALES = 2;

const ActaForm = ({ acta, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    empresa_nit: "", // Cambiado de empresa_nombre a empresa_nit
    hora_inicio: "",
    hora_fin: "",
    tipo_actividad: "auditoria",
    tipo_proceso: "revisoria",
    modalidad: "presencial",
    descripcion: "",
    nombre_persona: "",
    observaciones: "",
  });
  const [archivos, setArchivos] = useState([]); // +
  const [archivosPrevios, setArchivosPrevios] = useState([]); // +
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null); // +

  // Si estamos editando, cargar los datos del acta
  useEffect(() => {
    if (acta) {
      // Convertir fechas al formato correcto (YYYY-MM-DDThh:mm)
      const formatDateTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);

        // Asegurar que la fecha se maneje correctamente en la zona horaria local
        const pad = (n) => n.toString().padStart(2, "0");

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1); // Meses van de 0 a 11
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());

        return `${year}-${month}-${day}T${hours}:${minutes}`;
      };

      setFormData({
        empresa_nit: acta.empresa_nit || "", //-+
        hora_inicio: formatDateTime(acta.hora_inicio),
        hora_fin: formatDateTime(acta.hora_fin),
        tipo_actividad: acta.tipo_actividad || "auditoria",
        tipo_proceso: acta.tipo_proceso || "revisoria",
        modalidad: acta.modalidad || "presencial",
        descripcion: acta.descripcion || "",
        nombre_persona: acta.nombre_persona || "",
        observaciones: acta.observaciones || "",
      });
      // Guardar archivos previos si existen +
      if (acta.archivos_adjuntos && acta.archivos_adjuntos.length > 0) {
        //+
        setArchivosPrevios(acta.archivos_adjuntos); //+
      } //+
    }
  }, [acta]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        modalidad: checked ? "presencial" : "virtual",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  /////////////**************** desde aca */
  // Manejar selección de archivos
  const handleArchivosChange = (e) => {
    const nuevosArchivos = Array.from(e.target.files);

    // Validar tamaño máximo (10MB por archivo)
    const archivosValidos = nuevosArchivos.filter((archivo) => {
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (archivo.size > maxSize) {
        setError(`El archivo ${archivo.name} excede el tamaño máximo de 10MB`);
        return false;
      }
      return true;
    });

    if (archivosValidos.length > 0) {
      setArchivos((prev) => [...prev, ...archivosValidos]);
    }

    // Limpiar el input para poder seleccionar el mismo archivo otra vez
    e.target.value = "";
  };

  // Eliminar un archivo de la lista
  const eliminarArchivo = (index) => {
    setArchivos((prev) => prev.filter((_, i) => i !== index));
  };
  //////////////************hasta aca */
  const toggleModalidad = () => {
    setFormData((prev) => ({
      ...prev,
      modalidad: prev.modalidad === "presencial" ? "virtual" : "presencial",
    }));
  };

  // Función para formatear fecha para mostrar (DD/MM/YYYY)
  const formatDateForDisplay = (dateTimeString) => {
    if (!dateTimeString) return "";

    const [datePart, timePart] = dateTimeString.split("T");
    const [year, month, day] = datePart.split("-");

    return `${day}/${month}/${year} ${timePart || ""}`;
  };

  // Función para obtener la fecha mínima (hoy - 30 días) y máxima (hoy + 30 días)
  const getMinDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    return date.toISOString().slice(0, 10);
  };

  const getMaxDate = () => {
    const date = new Date();
    date.setDate(date.getDate() + 30);
    return date.toISOString().slice(0, 10);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Validar que la fecha de fin sea posterior a la de inicio
    if (formData.hora_inicio && formData.hora_fin) {
      const inicio = new Date(formData.hora_inicio);
      const fin = new Date(formData.hora_fin);

      if (fin <= inicio) {
        setError("La hora de fin debe ser posterior a la hora de inicio");
        return;
      }
    }

    // Validar que se haya seleccionado una empresa
    if (!formData.empresa_nit) {
      //+
      setError("Debe seleccionar una empresa"); //+
      return; //+
    } //+

    setLoading(true);

    try {
      // Crear copia de formData y asegurar que las fechas estén en formato correcto
      const submitData = { ...formData };

      // Asegurar que las fechas tengan segundos (formato ISO completo)
      if (submitData.hora_inicio && !submitData.hora_inicio.includes(":")) {
        submitData.hora_inicio += ":00";
      }
      if (submitData.hora_fin && !submitData.hora_fin.includes(":")) {
        submitData.hora_fin += ":00";
      }
      // DEBUG: Verificar archivos antes de enviar
      console.log('📎 Archivos a enviar:', archivos);
      console.log('📎 Cantidad de archivos:', archivos.length);

      if (archivos.length > 0) {
        console.log('📎 Validando archivos antes de enviar:');
        archivos.forEach((archivo, i) => {
          if (archivo instanceof File) {
            console.log(`   ✅ Archivo ${i+1}: ${archivo.name} - Es File válido`);
          } else {
            console.log(`   ❌ Archivo ${i+1} NO es File:`, archivo);
          }
        });
      }

      // Validar cantidad de archivos
      if (archivos.length > MAX_ARCHIVOS_INDIVIDUALES) {
        //+
        setError(
          `Máximo ${MAX_ARCHIVOS_INDIVIDUALES} archivos individuales. Si necesita más, comprímalos en ZIP, RAR o 7z.`,
        ); //+
        setLoading(false); //+
        return; //+
      } //+

      await onSubmit(submitData, archivos); //+
    } catch (err) {
      setError(err.message || "Error al guardar el acta");
    } finally {
      setLoading(false);
    }
  };

  const handleChangeNit = (nit, empresa) => {
    //+
    setFormData((prev) => ({ ...prev, empresa_nit: nit }));
    setEmpresaSeleccionada(empresa); //+
  };

  ////////////********desde aca */
  // Obtener icono según tipo de archivo
  const getIconoArchivo = (nombre) => {
    const extension = nombre.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "bmp"].includes(extension)) {
      return <PhotoIcon className="h-5 w-5 text-blue-500" />;
    } else if (extension === "pdf") {
      return <DocumentTextIcon className="h-5 w-5 text-red-500" />;
    } else if (["doc", "docx"].includes(extension)) {
      return <DocumentIcon className="h-5 w-5 text-blue-700" />;
    } else if (["xls", "xlsx"].includes(extension)) {
      return <DocumentIcon className="h-5 w-5 text-green-600" />;
    } else if (["zip", "rar", "7z"].includes(extension)) {
      return <ArchiveBoxIcon className="h-5 w-5 text-yellow-600" />;
    } else {
      return <DocumentIcon className="h-5 w-5 text-gray-500" />;
    }
  };

  // Formatear tamaño de archivo
  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };
  ////////////************hasta aca */

  // Tipos de actividad disponibles
  const tiposActividad = [
    { value: "auditoria", label: "Auditoría", icon: "🔍" },
    { value: "consultoria", label: "Consultoría", icon: "💼" },
    { value: "asesoria", label: "Asesoría", icon: "📋" },
    { value: "sagrilaft", label: "SAGRILAFT", icon: "🛡️" },
    { value: "revisoria", label: "Revisoría", icon: "📝" },
    { value: "capacitacion", label: "Capacitación", icon: "👨‍🏫" },
    { value: "otro", label: "Otro", icon: "📌" },
  ];

  // Tipos de procesos
  const tiposProcesos = [
    { value: "revisoria", label: "Revisoaria", icon: "👁️" },
    { value: "outsourcing", label: "Outsourcing", icon: "🤝" },
    { value: "asesoria", label: "Asesoría", icon: "💡" },
    { value: "auditoria", label: "Auditoría", icon: "🔍" },
    { value: "sagrilaft", label: "SAGRILAFT", icon: "🛡️" },
    { value: "comercial", label: "Comercial", icon: "💰" },
    { value: "financiero", label: "Financiero", icon: "\u{1F4CA}" },
  ];

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Encabezado */}
      <div className="border-b border-gray-200 pb-4">
        <h3 className="text-lg font-semibold text-gray-900">
          {acta ? "Editar Acta de Servicio" : "Nueva Acta de Servicio"}
        </h3>
        <p className="text-sm text-gray-500 mt-1">
          Complete los datos de la actividad realizada
        </p>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg flex items-start">
          <XMarkIcon className="h-5 w-5 mr-2 flex-shrink-0 mt-0.5" />
          <span>{error}</span>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Columna izquierda */}
        <div className="space-y-5">
          {/* Empresa NIT */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Empresa
            </label>
            <SelectCompanies
              value={formData.empresa_nit}
              onChange={handleChangeNit}
              placeholder="Seleccione una empresa" //+
            />
            {empresaSeleccionada && ( //+ hasta )}
              <p className="mt-1 text-xs text-gray-500">
                {empresaSeleccionada.nombre} - {empresaSeleccionada.nit}
              </p>
            )}
          </div>

          {/* Tipo de Actividad */}
          <div>
            <label
              htmlFor="tipo_actividad"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Tipo de Actividad *
            </label>
            <div className="relative">
              <select
                id="tipo_actividad"
                name="tipo_actividad"
                required
                value={formData.tipo_actividad}
                onChange={handleChange}
                className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm appearance-none bg-white"
              >
                {tiposActividad.map((tipo) => (
                  <option key={tipo.value} value={tipo.value}>
                    {tipo.icon} {tipo.label}
                  </option>
                ))}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  className="h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* Tipo de Proceso */}
          <div>
            <label
              htmlFor="tipo_proceso"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Tipo de Proceso *
            </label>
            <div className="relative">
              <select
                id="tipo_proceso"
                name="tipo_proceso"
                required
                value={formData.tipo_proceso}
                onChange={handleChange}
                className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm appearance-none bg-white"
              >
                {tiposProcesos.map((tipo) => (
                  <option key={tipo.value} value={tipo.value}>
                    {tipo.icon} {tipo.label}
                  </option>
                ))}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  className="h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* Modalidad (Checkbox) */}
          <div className="pt-2">
            <div className="flex items-center">
              <button
                type="button"
                onClick={toggleModalidad}
                className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                  formData.modalidad === "presencial"
                    ? "bg-green-600"
                    : "bg-gray-200"
                }`}
              >
                <span
                  className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                    formData.modalidad === "presencial"
                      ? "translate-x-5"
                      : "translate-x-0"
                  }`}
                />
              </button>
              <div className="ml-3 flex items-center">
                {formData.modalidad === "presencial" ? (
                  <>
                    <UserGroupIcon className="h-5 w-5 text-green-600 mr-2" />
                    <span className="text-sm font-medium text-gray-900">
                      Presencial
                    </span>
                  </>
                ) : (
                  <>
                    <ComputerDesktopIcon className="h-5 w-5 text-blue-600 mr-2" />
                    <span className="text-sm font-medium text-gray-900">
                      Virtual
                    </span>
                  </>
                )}
                <span className="ml-2 text-xs text-gray-500">
                  (Click para cambiar)
                </span>
              </div>
            </div>
            <p className="mt-2 text-xs text-gray-500">
              {formData.modalidad === "presencial"
                ? "La actividad se realizará de forma presencial en las instalaciones de la empresa."
                : "La actividad se realizará de forma virtual mediante videoconferencia o herramientas digitales."}
            </p>
          </div>

          {/* Nombre Persona */}
          <div>
            <label
              htmlFor="nombre_persona"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Nombre de la Persona que Realiza *
            </label>
            <input
              type="text"
              id="nombre_persona"
              name="nombre_persona"
              required
              value={formData.nombre_persona}
              onChange={handleChange}
              className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              placeholder="Nombre completo"
            />
          </div>
        </div>

        {/* Columna derecha - Fechas y Horas */}
        <div className="space-y-5">
          {/* Hora de Inicio */}
          <div>
            <label
              htmlFor="hora_inicio"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Fecha y Hora de Inicio *
            </label>
            <div className="space-y-2">
              <input
                type="date"
                name="fecha_inicio"
                required
                value={formData.hora_inicio.split("T")[0] || ""}
                onChange={(e) => {
                  const timePart =
                    formData.hora_inicio.split("T")[1] || "09:00";
                  setFormData((prev) => ({
                    ...prev,
                    hora_inicio: `${e.target.value}T${timePart}`,
                  }));
                }}
                min={getMinDate()}
                max={getMaxDate()}
                className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
              <div className="flex items-center space-x-2">
                <input
                  type="time"
                  name="hora_inicio_time"
                  required
                  value={formData.hora_inicio.split("T")[1] || ""}
                  onChange={(e) => {
                    const datePart =
                      formData.hora_inicio.split("T")[0] ||
                      new Date().toISOString().split("T")[0];
                    setFormData((prev) => ({
                      ...prev,
                      hora_inicio: `${datePart}T${e.target.value}`,
                    }));
                  }}
                  className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
                {formData.hora_inicio && (
                  <div className="text-xs bg-blue-50 text-blue-700 px-2 py-1 rounded">
                    {formatDateForDisplay(formData.hora_inicio)}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Hora de Fin */}
          <div>
            <label
              htmlFor="hora_fin"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Fecha y Hora de Fin *
            </label>
            <div className="space-y-2">
              <input
                type="date"
                name="fecha_fin"
                required
                value={formData.hora_fin.split("T")[0] || ""}
                onChange={(e) => {
                  const timePart = formData.hora_fin.split("T")[1] || "17:00";
                  setFormData((prev) => ({
                    ...prev,
                    hora_fin: `${e.target.value}T${timePart}`,
                  }));
                }}
                min={formData.hora_inicio.split("T")[0] || getMinDate()}
                max={getMaxDate()}
                className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
              <div className="flex items-center space-x-2">
                <input
                  type="time"
                  name="hora_fin_time"
                  required
                  value={formData.hora_fin.split("T")[1] || ""}
                  onChange={(e) => {
                    const datePart =
                      formData.hora_fin.split("T")[0] ||
                      new Date().toISOString().split("T")[0];
                    setFormData((prev) => ({
                      ...prev,
                      hora_fin: `${datePart}T${e.target.value}`,
                    }));
                  }}
                  className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
                {formData.hora_fin && (
                  <div className="text-xs bg-green-50 text-green-700 px-2 py-1 rounded">
                    {formatDateForDisplay(formData.hora_fin)}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Calculadora de horas */}
          {formData.hora_inicio && formData.hora_fin && (
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
              <div className="flex justify-between items-center mb-2">
                <span className="text-sm font-medium text-gray-700">
                  Duración estimada:
                </span>
                <span className="text-sm font-semibold text-blue-600">
                  {(() => {
                    try {
                      const inicio = new Date(formData.hora_inicio);
                      const fin = new Date(formData.hora_fin);
                      const diffMs = fin - inicio;
                      const diffHours = diffMs / (1000 * 60 * 60);
                      return `${diffHours.toFixed(2)} horas`;
                    } catch {
                      return "Cálculo no disponible";
                    }
                  })()}
                </span>
              </div>
              <div className="text-xs text-gray-500">
                {formData.hora_inicio.split("T")[0] ===
                formData.hora_fin.split("T")[0]
                  ? "Mismo día"
                  : "Actividad de varios días"}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Desde aca */}
      {/* SECCIÓN DE ARCHIVOS ADJUNTOS - NUEVA */}
      <div className="border-t border-gray-200 pt-5">
        <div className="flex items-center mb-3">
          <PaperClipIcon className="h-5 w-5 text-gray-500 mr-2" />
          <h4 className="text-md font-medium text-gray-900">
            Archivos Adjuntos
          </h4>
          <span className="ml-2 text-xs text-gray-500">
            (Máximo {MAX_ARCHIVOS_INDIVIDUALES} archivos individuales)
          </span>
        </div>

        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
          {/* Lista de archivos a subir */}
          {archivos.length > 0 && (
            <div className="mb-4">
              <p className="text-xs font-medium text-gray-700 mb-2">
                Archivos a adjuntar:
              </p>
              <div className="space-y-2">
                {archivos.map((archivo, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between bg-white p-2 rounded border border-gray-200"
                  >
                    <div className="flex items-center space-x-3">
                      {getIconoArchivo(archivo.name)}
                      <div>
                        <p className="text-sm font-medium text-gray-700 truncate max-w-xs">
                          {archivo.name}
                        </p>
                        <p className="text-xs text-gray-500">
                          {formatFileSize(archivo.size)}
                        </p>
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => eliminarArchivo(index)}
                      className="text-red-500 hover:text-red-700 p-1"
                    >
                      <TrashIcon className="h-4 w-4" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Selector de archivos */}
          <div className="flex items-center justify-center w-full">
            <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-white hover:bg-gray-50">
              <div className="flex flex-col items-center justify-center pt-5 pb-6">
                <ArrowUpTrayIcon className="h-8 w-8 text-gray-400 mb-2" />
                <p className="mb-2 text-sm text-gray-500">
                  <span className="font-semibold">Click para seleccionar</span>{" "}
                  o arrastra archivos
                </p>
                <p className="text-xs text-gray-500">
                  PDF, Word, Excel, Imágenes, ZIP, RAR, 7z (Max 10MB por
                  archivo)
                </p>
                {archivos.length >= MAX_ARCHIVOS_INDIVIDUALES && (
                  <p className="text-xs text-yellow-600 mt-2">
                    ⚠️ Has alcanzado el límite de archivos individuales
                  </p>
                )}
              </div>
              <input
                type="file"
                className="hidden"
                multiple
                onChange={handleArchivosChange}
                disabled={archivos.length >= MAX_ARCHIVOS_INDIVIDUALES}
                accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.txt,.zip,.rar,.7z"
              />
            </label>
          </div>

          {/* Mensaje informativo sobre compresión */}
          <div className="mt-3 text-xs text-gray-500 bg-blue-50 p-2 rounded">
            <p className="flex items-start">
              <span className="font-medium mr-1">ℹ️</span>
              Si necesita adjuntar más de {MAX_ARCHIVOS_INDIVIDUALES} archivos,
              comprímalos en un solo archivo ZIP, RAR o 7z.
            </p>
          </div>
        </div>
      </div>
      {/* Hasta aca */}

      {/* Descripción y Observaciones */}
      <div className="space-y-5">
        <div>
          <label
            htmlFor="descripcion"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Descripción de la Actividad *
          </label>
          <textarea
            id="descripcion"
            name="descripcion"
            required
            rows={4}
            value={formData.descripcion}
            onChange={handleChange}
            className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Describa detalladamente la actividad realizada..."
          />
          <p className="mt-1 text-xs text-gray-500">
            Incluya objetivos, procedimientos y hallazgos principales
          </p>
        </div>

        <div>
          <label
            htmlFor="observaciones"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Observaciones Adicionales
          </label>
          <textarea
            id="observaciones"
            name="observaciones"
            rows={3}
            value={formData.observaciones}
            onChange={handleChange}
            className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Agregue cualquier observación relevante..."
          />
          <p className="mt-1 text-xs text-gray-500">
            Notas, condiciones especiales, recomendaciones, etc.
          </p>
        </div>
      </div>

      {/* Resumen */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-center mb-2">
          <CheckIcon className="h-5 w-5 text-blue-600 mr-2" />
          <h4 className="text-sm font-semibold text-blue-800">
            Resumen del Acta
          </h4>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-xs">
          <div>
            <span className="text-gray-600">Tipo:</span>
            <span className="ml-2 font-medium capitalize">
              {formData.tipo_actividad}
            </span>
          </div>
          <div>
            <span className="text-gray-600">Proceso:</span>
            <span className="ml-2 font-medium capitalize">
              {formData.tipo_proceso}
            </span>
          </div>
          <div>
            <span className="text-gray-600">Modalidad:</span>
            <span
              className={`ml-2 font-medium ${
                formData.modalidad === "presencial"
                  ? "text-green-600"
                  : "text-blue-600"
              }`}
            >
              {formData.modalidad}
            </span>
          </div>
          <div>
            <span className="text-gray-600">Empresa:</span>
            <span className="ml-2 font-medium truncate">
              {formData.empresa_nombre || "Pendiente"}
            </span>
          </div>
          <div>
            <span className="text-gray-600">Responsable:</span>
            <span className="ml-2 font-medium truncate">
              {formData.nombre_persona || "Pendiente"}
            </span>
          </div>
          {/* dessde aca */}
          <div>
            <span className="text-gray-600">Archivos:</span>
            <span className="ml-2 font-medium">
              {archivos.length} archivo(s)
            </span>
          </div>
          {/* dessde aca */}
        </div>
      </div>

      {/* Botones de acción */}
      <div className="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-3 pt-4 border-t border-gray-200">
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="mt-3 sm:mt-0 w-full sm:w-auto px-4 py-2.5 border border-gray-300 rounded-lg shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Cancelar
        </button>
        <button
          type="submit"
          disabled={loading}
          className="w-full sm:w-auto px-4 py-2.5 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
        >
          {loading ? (
            <>
              <svg
                className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              Guardando...
            </>
          ) : (
            <>
              <CheckIcon className="h-4 w-4 mr-2" />
              {acta ? "Actualizar Acta" : "Crear Acta"}
            </>
          )}
        </button>
      </div>
    </form>
  );
};

export default ActaForm;
